import promotion from '@resources/js/components/promotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'

const initSharedPromotion = () => {
	const partnerType = getBcomOrExpediaPartnerType()

	promotion({
		links: {
			active: true,
			type: partnerType,
		},
		backbtn: {
			active: !!shared.options.bbcl,
			type: partnerType,
		},
		tab_change: {
			active: true,
			type: partnerType,
		},
		popup: {
			active: true,
			type: partnerType,
		},
		housesitter: {
			active: true,
		},
	})
}

export default initSharedPromotion
